import { Component, OnInit } from "@angular/core";
import { UserDetailsForm } from "./user-details.form";
import { UserService } from "../user.service";
import { UserDetails } from "../user-details.model";
import { AngularFireAuth } from "@angular/fire/auth";
import { switchMap, take } from "rxjs/operators";
import { AngularFirestoreDocument } from "@angular/fire/firestore";
import { UIControlService } from "src/app/shared/uicontrol.service";

@Component({
  selector: "app-user-details-layout",
  templateUrl: "./user-details-layout.component.html",
  styleUrls: ["./user-details-layout.component.scss"]
})
export class UserDetailsLayoutComponent implements OnInit {
  public formModel: UserDetailsForm;
  private userDetailsDocument: AngularFirestoreDocument<UserDetails>;
  public loading = true;
  public saving = false;

  constructor(
    private userService: UserService,
    private fireAuth: AngularFireAuth,
    private ui: UIControlService
  ) {}

  public ngOnInit(): void {
    var loggedInUser = this.fireAuth.auth;
    this.fireAuth.user
      .pipe(
        switchMap(fireAuthUser => {
          this.userDetailsDocument = this.userService.getUserDetails(
            fireAuthUser
          );
          return this.userDetailsDocument.valueChanges();
        }),
        take(1)
      )
      .subscribe(userDetails => {
        this.formModel = new UserDetailsForm(userDetails);
        this.loading = false;
      });
  }

  public save() {
    if (this.formModel.formGroup.valid) {
      this.saving = true;
      this.userDetailsDocument
        .update({ ...this.formModel.model })
        .then(() => {
          this.ui.notifySuccess("Details saved successfully!");
        })
        .catch(error => {
          console.error(error);
          this.ui.notifyFailure(
            "Could not save. Please try again in a few minutes."
          );
        })
        .finally(() => (this.saving = false));
    } else {
      this.ui.notifyFailure("Please correct the above details before saving");
    }
  }
}
